import React, { useState, useEffect } from 'react';
import {
  laneRateEmailConfirmation,
  laneRateAccessorialEmailConfirmation,
} from 'utils/AccessorialRequestWebAPIUtils';
import { showToast } from 'stores/ToastStore';
import CargomaticModal from '../../v2/modal';

export default function RatingEngineModal(props) {
  const { onCloseClick, from, type, rateType, token } = props;
  const [emailConfirmationSuccess, setEmailConfirmationSuccess] =
    useState(false);

  useEffect(() => {
    const getEmailConfirmation = async () => {
      try {
        console.log('RateType ', rateType)
        if (rateType === 'LaneRates') {
          const response = await laneRateEmailConfirmation(
            token,
            type ? 'confirmed' : 'declined',
          );
          setEmailConfirmationSuccess(response.entity.success);
        } else {
          const response = await laneRateAccessorialEmailConfirmation(
            token,
            type ? 'confirmed' : 'declined',
          );
          console.log('Response ', response)
          setEmailConfirmationSuccess(response.entity.success);
        }
      } catch (e) {
        console.error(
          'LandingModule, failed to get the emailConfirmation: ',
          e,
        );
        showToast(
          'Request Error',
          `Error while ${type ? 'confirming' : 'declining'} the rates.`,
          'error',
        );
      }
    };
    getEmailConfirmation();
  }, []);

  const renderBody = (type, from) => {
    const confirmText = `Your ${from} rates have been confirmed!.`;
    const declineText = `You have declined the ${from} Rate Card. The support team`;
    return (
      <div>
        {type ? (
          <h3 className="flex mb-0 justify-center">Congratulations!</h3>
        ) : (
          ''
        )}
        {type ? (
          <p className="flex justify-center">{confirmText}</p>
        ) : (
          <div>
            <p className="flex justify-center">{declineText}</p>
            <p className="flex justify-center">
              will reach out to you to review the details.
            </p>
            <p className="flex justify-center">Thank you!</p>
          </div>
        )}
        <div className="mt-10 flex justify-around">
          <button
            onClick={onCloseClick}
            className="absolute  bottom-2 button button-green"
          >
            Close
          </button>
        </div>
      </div>
    );
  };
  return (
    <CargomaticModal
      style={{ top: '35%' }}
      dialogClassName="rounded-xl border-4 border-green-cm w-1/3"
      showHeader={false}
      show={props.show && emailConfirmationSuccess}
      onHide={() => {}}
      body={renderBody(type, from)}
    />
  );
}
